<template>
    <div class="container">    
        <div class="row">

            <div class="col-md-2"></div>

            <div class="col-md-8 ">
                <div class="row style-padding-title">
                    <div class="col-md-2">
                        <img width="140" height="43" :src="$image_url('logo_tigre_branca.png')" alt="Logo Tigre">
                    </div>
                    <div class="col-md-10 style-title">
                        <h5 >Assinatura/Firma/Sign Grupo Tigre</h5>
                    </div>
                </div>
                <FormSignatureEmail/>
            </div>
        </div>
    </div>
</template>

<script>

  import "bootstrap/dist/css/bootstrap.min.css";
  import FormSignatureEmail from './FormSignatureEmail.vue';

  export default {
    name: 'HeaderForm',
    components: {
        FormSignatureEmail
    }
  }
</script>